import React from 'react';
import SearchApiAccount from '../components/search-api/all-space-account';
import SearchApiIndex from '../components/search-api/all-space-index';

export const useSearchIndex = (): SearchApiIndex => {
  return React.useMemo(() => SearchApiAccount.getInstance().indices.allSpace(), []);
};
